export enum PendType {
  PC100 = 1,
  PC101 = 2,
  PC102 = 3,
  PC103 = 4,
  PC104 = 5,
  PC105 = 7,
  PC106 = 8,
  PC107 = 9,
  PC108 = 10,
  PC109 = 11,
  PC110 = 12,
  PC140 = 77,
  PC301 = 52,
  PC131 = 61,
  PC304 = 63,
  PC700 = 65,
  PC143 = 84,
  PC1031 = 85,
}

// Pend codes that can only be created by the backend and must not be selectable in create/edit pend forms
// or the SO Settings Pend Code Manager, but should still appear in filter dropdowns (chase, pend query, etc).
export const backendOnlyPC: PendType[] = [PendType.PC143, PendType.PC1031];

